import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout2 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class ImageView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="ImageView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

ImageView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

ImageView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "ImageView",
    action: {
      url: "",
      target: ""
    },
    width: "100%",
    imageUrl: {
      url: "",
      urlMobile: "",
      desktop: {
        width: 0,
        height: 0
      },
      mobile: {
        width: 0,
        height: 0
      }
    },
    altText: "Image one",
    containerPadding: "0px",
    align: "center",
    animation: {
      direction: "fade",
      show: false,
      duration: 1000,
      type: "ease both"
    },
    href: {
      url: "",
      target: "",
      isCollection: false,
      collection: 0
    }
  },
  layout: Layout2
};
export default ImageView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/ImageView.js